import chroma from "chroma-js";

const lightScale = chroma
  .scale(["#FFCFCF", "#FFF0A2", "#BDFFC4"])
  .mode("lch")
  .domain([0, 100]);

const darkScale = chroma
  .scale(["#F14B69", "#ECA816", "#31C467"])
  .mode("lch")
  .domain([0, 100]);

const toSafePercent = (percent) => {
  const numericValue = Number.parseFloat(percent);
  if (Number.isNaN(numericValue)) return 0;
  return Math.max(0, Math.min(100, numericValue));
};

const gradientColor = (percent, options = {}) => {
  const { darkMode = false } = options;
  const scale = darkMode ? darkScale : lightScale;
  return scale(toSafePercent(percent)).hex();
};

export default gradientColor;
